module.exports = __webpack_public_path__ + "static/media/bg_watercolor_pink.92e08563.png";